import { useState, useEffect } from "react";
import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Dialog,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    IconButton,
    Collapse,
    Button
  } from "@mui/material";
  import {
    Notifications,
    Menu,
    Dashboard,
    ExpandLess,
    ExpandMore,
    Storage,
    ShoppingCart,
    BusinessCenter,
    Apartment,
    ChevronLeft,
    Logout
  } from "@mui/icons-material";
  import { useNavigate } from "react-router-dom";

const Header = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [openSignOutDialog, setOpenSignOutDialog] = useState(false);
  const [username,setUsername] = useState("");

  const navigate = useNavigate();

  const handleOpenSignOutDialog = () => {
    setOpenSignOutDialog(true);
  };
  
  const handleCloseSignOutDialog = () => {
    setOpenSignOutDialog(false);
  };
  
  const handleSignOut = async () => {
    await localStorage.removeItem("token");
    await localStorage.removeItem("roles");
    // alert("User Signed Out");
    // Tambahkan logika sign-out di sini, misalnya menghapus token dari localStorage
    await setOpenSignOutDialog(false);
    await navigate("/login");
  };


  useEffect(() => {
    const date = new Date();
    const options: Intl.DateTimeFormatOptions = { day: "numeric", month: "long", year: "numeric" };
    setCurrentDate(date.toLocaleDateString("id-ID", options));
    setUsername(localStorage.getItem("username")||'')
  }, []);

  return (
    <Box
      sx={{
        // width: "100%",
        px: 3,
        py: 1,
        borderBottom: "1px solid #E8E8E8",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "white",
      }}
    >
      {/* Kiri: Salam dan Tanggal */}
      <Box display="flex" alignItems="center" gap={3}>
        <Typography fontSize={24} fontWeight={700} color="#191919">
          Hello {username}
        </Typography>
        <Typography fontSize={14} color="#9F9F9F">
          {currentDate}
        </Typography>
      </Box>

      {/* Kanan: Sign Out */}
      <Box>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Logout />}
          onClick={handleOpenSignOutDialog}
          sx={{ bgcolor: "#FFEBA6", color: "black", "&:hover": { bgcolor: "#B71C1C" } }}
        >
          Sign Out
        </Button>
      </Box>

      {/* Popup konfirmasi Signout */}
      <Dialog open={openSignOutDialog} onClose={handleCloseSignOutDialog} fullWidth maxWidth="xs"
  sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
  <DialogContent sx={{ textAlign: "center", padding: "24px" }}>
    <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
      <span style={{ fontSize: "24px", color: "red" }}>⭐</span>
    </Box>
    <Typography variant="h6" fontWeight="bold">
      Apakah anda yakin untuk keluar
    </Typography>
    <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
      Ketika keluar anda akan memerlukan login kembali ke aplikasi SIMPRO
    </Typography>
  </DialogContent>

  <DialogActions sx={{ justifyContent: "center", padding: "16px" }}>
    <Button variant="text" sx={{ color: "#14BA6D", fontWeight: "bold" }} onClick={handleCloseSignOutDialog}>
      CANCEL
    </Button>
    <Button variant="contained" sx={{ backgroundColor: "red", color: "#fff", borderRadius: "8px" }} onClick={handleSignOut}>
      SIGN OUT
    </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default Header;
